module.exports = __webpack_public_path__ + "img/role3.b1459d3a.png";